import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Image, Text, View } from "react-native";
import { styledRN } from "../styled";
import { FontAwesomeIconCtx } from "../platform";
import { Button } from "../button";
import { Modal } from "../modal/modal";
import { Input } from "../input/input";
const ModalContainer = styledRN(View, ({ $theme }) => ({
    backgroundColor: $theme.background1,
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 20,
    gap: 20,
}));
const Title = styledRN(Text, ({ $theme }) => ({
    fontWeight: 'bold',
    fontSize: 36,
    color: 'white',
    fontFamily: 'hiyllo',
    textAlign: 'center',
}));
const Description = styledRN(Text, ({ $theme }) => ({
    marginTop: 10,
    fontSize: 18,
    color: 'white',
    fontFamily: 'hiyllo',
    textAlign: 'center',
}));
export const DialogNative = React.memo(function DialogNative(props) {
    const FontAwesomeIcon = React.useContext(FontAwesomeIconCtx);
    const [confirming, setConfirming] = React.useState(false);
    const [value, setValue] = React.useState(props.defaultValue ?? null);
    const onConfirm = React.useCallback(async () => {
        if (props.requireValue && (value == null || value.length < 1)) {
            return;
        }
        setConfirming(true);
        if ('onConfirm' in props) {
            await props.onConfirm?.(value ?? '');
        }
        setConfirming(false);
    }, [props, value]);
    const closeAnd = React.useCallback((fn) => {
        return () => {
            props.onClose();
            fn();
        };
    }, [props]);
    return (_jsx(Modal, { onClose: props.onClose, children: _jsxs(ModalContainer, { children: [FontAwesomeIcon != null && props.icon != null ? ("src" in props.icon ? (_jsx(Image, { source: { uri: props.icon.src }, style: { width: 60, height: 60 } })) : (_jsx(FontAwesomeIcon, { icon: props.icon, size: 60, color: "white" }))) : null, _jsxs(View, { children: [_jsx(Title, { children: props.title }), _jsx(Description, { children: props.message })] }), props.requireValue ? (_jsx(Input, { startEnhancer: props.inputStartEnhancer, autoFocus: true, onChangeValue: setValue, value: value ?? "" })) : null, props.extras, _jsx(View, { style: { height: 0, flexGrow: 1 } }), _jsx(View, { style: {
                        width: '100%',
                        paddingLeft: 0,
                        paddingRight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 10,
                    }, children: props.buttons.map((button, i) => {
                        return (_jsx(Button, { label: button.label, onClick: button.onClick === 'submit'
                                ? onConfirm
                                : closeAnd(button.onClick), isSecondary: button.type === 'secondary' }, i));
                    }) })] }) }));
});
